import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUser } from '../../../models/user';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'andor-user-name',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './user-name.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './user-name.scss',
})
export class UserName {
  @Input() user!: SharedUser;
}
